/* tslint:disable */
/* eslint-disable */
/**
 * API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../../common/runtime';
import type { ImportResults } from './ImportResults';
import {
  ImportResultsFromJSON,
  ImportResultsFromJSONTyped,
  ImportResultsToJSON,
} from './ImportResults';

/**
 *
 * @export
 * @interface CsvPatch
 */
export interface CsvPatch {
  /**
   * Start the import process with action=import
   * @type {string}
   * @memberof CsvPatch
   */
  action?: CsvPatchActionEnum;
  /**
   * A map of csv column name to Lead.custom[x]
   * @type {{ [key: string]: string; }}
   * @memberof CsvPatch
   */
  customMapping?: { [key: string]: string };
  /**
   *
   * @type {ImportResults}
   * @memberof CsvPatch
   */
  importResults?: ImportResults;
  /**
   *
   * @type {Array<any>}
   * @memberof CsvPatch
   */
  labels?: Array<any>;
  /**
   * A map of csv column name to Lead attribute name
   * @type {{ [key: string]: string; }}
   * @memberof CsvPatch
   */
  leadMapping?: { [key: string]: string };
  /**
   *
   * @type {string}
   * @memberof CsvPatch
   */
  name?: string;
  /**
   * The strategy to use when de-duping a csv at import time
   * @type {string}
   * @memberof CsvPatch
   */
  strategy?: CsvPatchStrategyEnum;
}

/**
 * @export
 */
export const CsvPatchActionEnum = {
  Import: 'import',
} as const;
export type CsvPatchActionEnum =
  (typeof CsvPatchActionEnum)[keyof typeof CsvPatchActionEnum];

/**
 * @export
 */
export const CsvPatchLeadMappingEnum = {
  DoNotImport: 'do_not_import',
  FirstName: 'first_name',
  LastName: 'last_name',
  JobTitle: 'job_title',
  Industry: 'industry',
  Role: 'role',
  Department: 'department',
  ExternalId: 'external_id',
  Timezone: 'timezone',
  Lang: 'lang',
  PrimaryPhone: 'primary_phone',
  SecondaryPhone: 'secondary_phone',
  PrimaryEmail: 'primary_email',
  SecondaryEmail: 'secondary_email',
  AddressName: 'address_name',
  AddressLine1: 'address_line1',
  AddressLine2: 'address_line2',
  City: 'city',
  Region: 'region',
  PostalCode: 'postal_code',
  Country: 'country',
  CompanyName: 'company_name',
  CompanyPhone: 'company_phone',
  CompanyAddressLine1: 'company_address_line1',
  CompanyAddressLine2: 'company_address_line2',
  CompanyCity: 'company_city',
  CompanyRegion: 'company_region',
  CompanyPostalCode: 'company_postal_code',
  CompanyCountry: 'company_country',
  CompanySicCode: 'company_sic_code',
  CompanyNaicsCode: 'company_naics_code',
  CompanyBlacklisted: 'company_blacklisted',
  CompanyAnnualRevenue: 'company_annual_revenue',
  CompanyCurrency: 'company_currency',
  CompanyNumEmployees: 'company_num_employees',
} as const;
export type CsvPatchLeadMappingEnum =
  (typeof CsvPatchLeadMappingEnum)[keyof typeof CsvPatchLeadMappingEnum];

/**
 * @export
 */
export const CsvPatchStrategyEnum = {
  Skip: 'skip',
  Merge: 'merge',
} as const;
export type CsvPatchStrategyEnum =
  (typeof CsvPatchStrategyEnum)[keyof typeof CsvPatchStrategyEnum];

/**
 * Check if a given object implements the CsvPatch interface.
 */
export function instanceOfCsvPatch(value: object): value is CsvPatch {
  return true;
}

export function CsvPatchFromJSON(json: any): CsvPatch {
  return CsvPatchFromJSONTyped(json, false);
}

export function CsvPatchFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): CsvPatch {
  if (json == null) {
    return json;
  }
  return {
    action: json['action'] == null ? undefined : json['action'],
    customMapping:
      json['custom_mapping'] == null ? undefined : json['custom_mapping'],
    importResults:
      json['import_results'] == null
        ? undefined
        : ImportResultsFromJSON(json['import_results']),
    labels: json['labels'] == null ? undefined : json['labels'],
    leadMapping:
      json['lead_mapping'] == null ? undefined : json['lead_mapping'],
    name: json['name'] == null ? undefined : json['name'],
    strategy: json['strategy'] == null ? undefined : json['strategy'],
  };
}

export function CsvPatchToJSON(value?: CsvPatch | null): any {
  if (value == null) {
    return value;
  }
  return {
    action: value['action'],
    custom_mapping: value['customMapping'],
    import_results: ImportResultsToJSON(value['importResults']),
    labels: value['labels'],
    lead_mapping: value['leadMapping'],
    name: value['name'],
    strategy: value['strategy'],
  };
}
